module.exports = __webpack_public_path__ + "static/media/share.c9b75914.svg";